// @ts-nocheck
import { USER_ROLES, USER_ROLES_MAP } from "./constant";

/**
 * Reseller / company (end-user) creators may only set Call Centre Admin
 * as the default user when creating a call centre.
 */
export function mustForceCallCentreAdminDefaultUser(creatorRole) {
  return (
    creatorRole === USER_ROLES.COMPANY_ADMIN ||
    creatorRole === USER_ROLES.RESELLER
  );
}

/**
 * Filters default-user role options for call-centre create.
 * Injects Call Centre Admin if ACL create-roles omit it.
 */
export function filterDefaultCallCentreUserRoles(roleOptions, creatorRole) {
  const options = Array.isArray(roleOptions) ? roleOptions : [];

  if (!mustForceCallCentreAdminDefaultUser(creatorRole)) {
    return options;
  }

  const ccAdmin =
    options.find((opt) => opt?.value === USER_ROLES.CALL_CENTRE_ADMIN) || {
      value: USER_ROLES.CALL_CENTRE_ADMIN,
      label:
        USER_ROLES_MAP[USER_ROLES.CALL_CENTRE_ADMIN] || "Call Centre Admin User",
    };

  return [ccAdmin];
}

/** @deprecated Use mustForceCallCentreAdminDefaultUser */
export function isCompanyUserCreatingCallCentre(creatorRole) {
  return mustForceCallCentreAdminDefaultUser(creatorRole);
}

export function resolveCallCentreDefaultUserRole(creatorRole, selectedRole) {
  if (mustForceCallCentreAdminDefaultUser(creatorRole)) {
    return USER_ROLES.CALL_CENTRE_ADMIN;
  }
  return selectedRole || USER_ROLES.CALL_CENTRE_ADMIN;
}
